module.exports = __webpack_public_path__ + "static/BookAnAppointment-49c30ee7b02b28b9b3845d21865f9a50.svg";